var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pan-simple-header'),_c('div',{staticClass:"code-text-content"},[_c('pre',{staticClass:"layui-code code-text"},[_vm._v("            "+_vm._s(_vm.codeContent)+"\n        ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }